(function () {
  const SWIPER_TIMEOUT_MS = 5000;

  const waitForSwiper = () =>
    new Promise((resolve, reject) => {
      if (window.Swiper) return resolve(window.Swiper);
      const start = Date.now();
      const id = setInterval(() => {
        if (window.Swiper) {
          clearInterval(id);
          resolve(window.Swiper);
        } else if (Date.now() - start > SWIPER_TIMEOUT_MS) {
          clearInterval(id);
          reject(new Error('Swiper not available within ' + SWIPER_TIMEOUT_MS + 'ms'));
        }
      }, 50);
    });

  class RealResultsSection extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this._realResultsNavMq = null;
      this._realResultsNavMqHandler = null;
      this._onQuizResults = this._onQuizResults.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
    }

    connectedCallback() {
      document.addEventListener('quiz:results-ready', this._onQuizResults);
      document.addEventListener('complexion-quiz:results-ready', this._onQuizResults);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
      this._bootstrap();
    }

    disconnectedCallback() {
      document.removeEventListener('quiz:results-ready', this._onQuizResults);
      document.removeEventListener('complexion-quiz:results-ready', this._onQuizResults);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
      this._teardownNavMq();
      this._destroySwiper();
    }

    _bootstrap() {
      waitForSwiper()
        .then(() => this.initSwiper())
        .catch((err) => console.error('[quiz-real-result]', err));
    }

    _onQuizResults() {
      waitForSwiper()
        .then(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.initSwiper();
            });
          });
        })
        .catch((err) => console.error('[quiz-real-result]', err));
    }

    _onSectionLoad(event) {
      const target = event && event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._bootstrap();
      }
    }

    _teardownNavMq() {
      if (this._realResultsNavMqHandler && this._realResultsNavMq) {
        this._realResultsNavMq.removeEventListener('change', this._realResultsNavMqHandler);
        this._realResultsNavMq = null;
        this._realResultsNavMqHandler = null;
      }
    }

    _destroySwiper() {
      this._teardownNavMq();
      if (this.swiper && typeof this.swiper.destroy === 'function') {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    initSwiper() {
      if (!window.Swiper) return;

      const carousel = this.querySelector('.js-real-results-carousel');
      const prevBtn = this.querySelector('.js-real-results-prev');
      const nextBtn = this.querySelector('.js-real-results-next');
      const pagination = this.querySelector('.js-real-results-pagination');

      if (!carousel) return;

      this._destroySwiper();

      const slideCount = carousel.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      const isComplexionQuiz = document.body?.dataset?.template === 'complexion-quiz';
      const desktopMq = window.matchMedia('(min-width: 1025px)');
      const enableLoop = slideCount > 1;

      const updateRealResultsNavVisibility = () => {
        if (!prevBtn || !nextBtn) return;
        const hideArrows = isComplexionQuiz && desktopMq.matches && slideCount <= 3;
        prevBtn.toggleAttribute('hidden', hideArrows);
        nextBtn.toggleAttribute('hidden', hideArrows);
      };

      this._realResultsNavMq = desktopMq;
      this._realResultsNavMqHandler = updateRealResultsNavVisibility;
      desktopMq.addEventListener('change', updateRealResultsNavVisibility);

      this.swiper = new window.Swiper(carousel, {
        loop: enableLoop,
        loopedSlides: enableLoop ? slideCount : undefined,
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        watchOverflow: !enableLoop,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        pagination: {
          el: pagination,
          clickable: true,
          dynamicBullets: false,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.2,
            centeredSlides: true,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: false,
          },
          1025: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
          },
        },
      });

      updateRealResultsNavVisibility();
      requestAnimationFrame(() => {
        if (!this.swiper) return;
        this.swiper.update();
        if (enableLoop && typeof this.swiper.slideToLoop === 'function') {
          this.swiper.slideToLoop(0, 0);
        } else {
          this.swiper.slideTo(0, 0);
        }
      });
    }
  }

  if (!customElements.get('real-results-section')) {
    customElements.define('real-results-section', RealResultsSection);
  }
})();
